// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  API_URL: "https://api-dev.box593.com/app_dev.php/",
 // API_URL: "http://localhost:81/box593-api/web/app_dev.php/",

  CHAT_URL: "wss://api.box593.com/wss2/"
};



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/profit-dev/src/environments/environment.ts